import { render, staticRenderFns } from "./tzsbyy.vue?vue&type=template&id=275ab590"
import script from "./tzsbyy.vue?vue&type=script&lang=js"
export * from "./tzsbyy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports